import React from "react";
import { transformation } from "../../data/program";
export function Transformation() {
  return <section className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:py-28" data-id="element-213" data-mp="1rqtbyttosk5m">
      <div className="grid gap-12 md:grid-cols-[1fr_1.3fr] md:gap-20" data-id="element-214" data-mp="1nphkeir95ous">
        <div data-id="element-215" data-mp="1npr7nykwxhws">
          <h2 className="font-display text-4xl font-black uppercase leading-none md:text-5xl" data-id="element-216" data-mp="1nrc45tqsfaxa">
            Porque el dinero no fue la mayor transformación.
          </h2>
          <p className="mt-6 text-lg text-paper/70" data-id="element-217" data-mp="2fg5l5tp0ks7x">La mayor transformación fue convertirme en una persona capaz de:</p>
        </div>
        <div data-id="element-218" data-mp="26odcnojjvt5z">
          <ul className="divide-y divide-line border-y border-line" data-id="element-219" data-mp="26o3lvyqolhz8">
            {transformation.map(item => <li key={item} className="py-3.5 font-display text-xl font-bold md:py-4 md:text-3xl" data-id="element-220" data-mp="21q237ex63koa">
                {item}
              </li>)}
          </ul>
          <p className="mt-8 text-lg text-paper/70" data-id="element-221" data-mp="2udxycf7394iy">Y sobre todo:</p>
          <p className="mt-2 font-display text-4xl font-black uppercase text-accent md:text-5xl" data-id="element-222" data-mp="2ucmuyghk1ysd">Tener fe en el proceso.</p>
        </div>
      </div>
    </section>;
}